module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"preview":"Предпросмотр"}}')
  delete Component.options._Ctor
}
